import React from 'react';

// page heading component
export default function PageHeading({ title }) {
  return (
    <div
      className={
        'py-3 d-flex justify-content-center align-items-center' + ' text-center'
      }
    >
      <span className="fs-2 fw-bold border-bottom px-2">{title}</span>
    </div>
  );
}
